/* eslint-disable no-console */
import * as Sentry from "@sentry/gatsby";
import { CaptureConsole, HttpClient } from "@sentry/integrations";
import {
  beforeBreadcrumb,
  beforeSend,
  // beforeSendTransaction,
} from "./src/utils/sentryCustomMethods";

const getCurrentEnvironment = () => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;

    if (hostname.includes("staging.sonesta.com")) {
      return "staging";
    } else if (hostname.includes("www.sonesta.com")) {
      return "production";
    } else if (hostname.includes("mobile.sonesta.com")) {
      return "mobile";
    } else if (hostname.includes("localhost")) {
      return "development";
    }
  }

  return "unknown";
};

const environment = getCurrentEnvironment();

Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN,

  integrations: [
    new Sentry.BrowserTracing(),
    new Sentry.Replay({
      networkDetailAllowUrls: ["/.netlify/functions/upgradeReservationNor1Api"],
      networkRequestHeaders: ["X-Custom-Header"],
      networkResponseHeaders: ["X-Custom-Header"],
    }),
    new HttpClient(),
    new CaptureConsole({
      levels: ["error"],
    }),
  ],
  debug: false,
  beforeBreadcrumb,
  beforeSend,
  // beforeSendTransaction,
  // Performance Monitoring
  tracesSampleRate: 0.1,

  // Session Replay
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 0.5,
  denyUrls: [
    /extensions\//i, // Chrome extensions
    /^chrome:\/\//i, // Chrome internal URLs
    /http:\/\/localhost/i, // Localhost development URLs
    /http:\/\/127\.0\.0\.1/i, // Localhost IP development URLs
    /.*\.google-analytics\.com/, // Google Analytics
    /.*\.facebook\.net/, // Facebook
    /.*\.doubleclick\.net/, // DoubleClick
    /.*\.googletagmanager\.com/, // Google Tag Manager
    /.*\.azure\.com/, // Azure analytics
  ],

  environment,
});
